module.exports = __webpack_public_path__ + "static/media/banner-1.57f8267d.webp";